module.exports = __webpack_public_path__ + "static/media/logo-small.9e7bcff5.svg";